import { initSwiper } from '@resources/js/components/initSwiper.js';
import inViewport from '@resources/js/helpers/inViewport';
const roomsSectionElement = document.querySelector('.js-hotel-rooms');
inViewport(roomsSectionElement, () => {
    const roomCards = roomsSectionElement.querySelectorAll('.js-card');
    roomCards.forEach(roomCard => {
        inViewport(roomCard, () => {
            const sliderContainerElement = roomCard.querySelector('.js-slider-container');
            if (!sliderContainerElement)
                return;
            const sliderElement = sliderContainerElement.querySelector('.js-slider');
            if (!sliderElement)
                return;
            const sliderConfig = {
                spaceBetween: 0,
                navigation: {
                    nextEl: sliderContainerElement.querySelector('.js-slider-next'),
                    prevEl: sliderContainerElement.querySelector('.js-slider-prev'),
                },
                pagination: {
                    el: sliderContainerElement.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    dynamicBullets: true,
                },
            };
            initSwiper(sliderElement, sliderConfig);
        });
    });
});
